import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cw-splash',
  templateUrl: './splash.component.html'
})
export class SplashComponent implements OnInit {

  private logo = require('@c4/assets/src/assets/images/c4-logo-white.png');

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/splash/splash.component.ts